import {sendMonitor} from '~/utils/util';

const AihcMonitor = (data: {action?: string; category?: string; name?: string; value?: string}) => {
    sendMonitor(data);
};

export default AihcMonitor;
